import type { RouteRecordRaw, RouteComponent } from 'vue-router'
import { PageTypes } from '@core/constants/pages'

export function getLandingRoutes(component: RouteComponent): RouteRecordRaw[] {
  return [
    {
      name: 'landing',
      path: `/${LANG_PARAM}/:folder?/:uid`,
      meta: { pageType: PageTypes.LANDING },
      component,
    },
    {
      name: 'cluster',
      path: `/${LANG_PARAM}/:path+`,
      meta: { pageType: PageTypes.LANDING },
      component,
    },
  ]
}
